import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-ez-bg">
      <Navbar />
      <main className="flex-1 pt-16 md:pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
}

// Standard interior page hero
export function PageHeader({ eyebrow, title, subtitle, dark = false, image, imageAlt = "" }) {
  return (
    <section
      className={`relative overflow-hidden border-b ${
        dark ? "bg-os-bg text-white border-white/10 grain" : "bg-ez-bg text-ez-text border-ez-text"
      }`}
    >
      <div className={`absolute inset-0 ${dark ? "grid-bg-dark opacity-40" : "grid-bg opacity-60"}`} />
      <div className="relative max-w-[1600px] mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className={image ? "lg:col-span-7" : "lg:col-span-12"}>
          {eyebrow && (
            <div className={`font-mono-ez text-xs uppercase tracking-[0.3em] mb-6 ${dark ? "text-ez-yellow" : "text-ez-text/50"}`}>
              {eyebrow}
            </div>
          )}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl uppercase tracking-tighter max-w-4xl leading-[0.92]">
            {title}
          </h1>
          {subtitle && (
            <p className={`mt-8 max-w-2xl text-base md:text-lg leading-relaxed ${dark ? "text-white/60" : "text-ez-text/70"}`}>
              {subtitle}
            </p>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5">
            <div className={`relative border ${dark ? "border-white/20" : "border-ez-text"}`}>
              <img src={image} alt={imageAlt} className="w-full h-64 lg:h-80 object-cover" loading="eager" />
              <div className={`absolute inset-0 ${dark ? "bg-ez-yellow/5" : "bg-ez-text/5"}`} />
              <div className="absolute bottom-0 left-0 right-0 h-1.5 hazard" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
